import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayouts from "../layouts/footer.layout";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import BannerComponent from "../components/concesionarios/banner.component";
import ContenidoComponent from "../components/concesionarios/contenido.component";
import { ConcesionariosAll } from "../components/conexion/vehicles.conexion";
import OtrosVehiculosComponent from "../components/concesionarios/otros-vehiculos.component";

/*eslint-disable */

declare const window: any;

const ConcesionariosPage: React.FC = () => {
  const [visibleHeight, setVisibleHeight] = useState(0);
  const [concesionarios, setConcesionarios] = useState([]);

  useEffect(() => {
    ConcesionariosAll().then(function (res: any) {
      const concessionairesWithCity = res?.data?.data.flatMap((item: any) =>
        item.concessionaires.map((concessionaire: any) => ({
          ...concessionaire, // Desestructuramos el concesionario
          city: item.city, // Agregamos el parámetro city desde el item principal
        }))
      );
      setConcesionarios(concessionairesWithCity);
    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      const dataLayerEvent: any = {
        event: "dealer_locator_click",
        comp_page: {
          position: "top menu",
        },
      };

      // Empujar al dataLayer
      if (window.dataLayer) {
        window.dataLayer.push(dataLayerEvent);
      }
    }, 0);
  }, []);

  return (
    <>
      <MenuLayouts
        className="home-page"
        active="concesionario"
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div
        className="home-page" /* style={{backgroundColor: "#F6F3F2", height: "100vh"}} */
      >
        <div className="home-page-mascara"></div>
        <BannerComponent />
        <ContenidoComponent concesionarios={concesionarios} />
        <OtrosVehiculosComponent />
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default ConcesionariosPage;
